// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"checkbox-container-heGq4","toggle":"toggle-jrHgS"};